<template>
  <v-container fluid>
    <v-card flat>
      <v-container>
        <v-card-title>
          <h4 class="earth-color">ADD ACTIVITY/ITEM</h4>
        </v-card-title>
        <hr />
        <v-form @submit.prevent="postInventory()">
          <v-layout row wrap>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Income Account Code"
                              v-model="inventory.code"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Outlet Analysis Code" v-model="inventory.sub_code"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Department Analysis Code"
                              v-model="inventory.analysis_code"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Activity Name"
                              v-model="inventory.name"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Maximum Guests"
                              v-model="inventory.maximum_guests"
                              :rules="requiredRules"
                              required
                              type="number"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container>
                <v-switch label="VAT" v-model="inventory.vat" color="primary" required></v-switch>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container>
                <v-switch label="Catering Levy "
                          v-model="inventory.categing_levy"
                          color="primary"
                          required></v-switch>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container>
                <v-switch label="Is a Ranger?"
                          v-model="inventory.ranger_marker"
                          color="primary"
                          required></v-switch>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container>
                <v-switch label="Has Extras?"
                          v-model="inventory.has_extras"
                          color="primary"
                          required></v-switch>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Google Analytics Code"
                              v-model="inventory.google_analytics_code"
                              type="text"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Facebook Conversion Tag"
                              v-model="inventory.facebook_tag"
                              type="text"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg12 md12 sm12 xs12>
              <v-container fluid>
                <label>Description</label>
                <vue-editor v-model="inventory.description"></vue-editor>
              </v-container>
            </v-flex>
            <v-flex lg12 md12 sm12 xs12>
              <v-container fluid>
                <v-btn :depressed="true"
                       color="primary"
                       v-if="this.$route.name === 'NewInventory'"
                       type="submit"
                       :loading="this.$store.state.LoadingStore.loading">Add to Inventory</v-btn>
                <v-btn :depressed="true"
                       color="primary"
                       v-if="this.$route.name === 'EditInventory'"
                       type="submit"
                       :loading="this.$store.state.LoadingStore.loading">Update Inventory</v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
    {{updateInventory}}
  </v-container>
</template>

<script>
  import { VueEditor } from "vue2-editor";
  export default {
    data() {
      return {
        requiredRules: [(v) => !!v || "This field is required"],
        inventory: {
          name: "",
          vat: "false".toLowerCase(),
          categing_levy: "false".toLowerCase(),
          ranger_marker: "false".toLowerCase(),
          has_extras: "false".toLowerCase(),
          code: "",
          sub_code: "",
          maximum_guests: "",
          analysis_code: "",
          description: "",
          public_id: this.$route.params.inventory_id,
          session_id: localStorage.getItem("lkjhgfdsa"),
          google_analytics_code: "",
          facebook_tag: "",
        },
      };
    },
    created() {
      this.$store.dispatch("get_all_activity_currencies");
      if (this.$route.name === "EditInventory") {
        this.$store.dispatch("get_activity", this.$route.params.inventory_id);
      }
    },
    components: {
      VueEditor,
    },
    methods: {
      postInventory: function () {
        this.$store.dispatch("loading_true");
        if (this.$route.name === "NewInventory") {
          this.$store.dispatch("post_activity", this.inventory);
        } else {
          this.$store.dispatch("update_activity", this.inventory);
        }
      },
    },
  };
</script>

<style>
</style>
